module.exports = __webpack_public_path__ + "assets/b1f482cb6619d2734f5ecce1a0e9c847.mp3";